import { createRoot } from 'react-dom/client';

import App from './App';

const container = document.getElementById('WIT-ROOT');
const root = createRoot(container!);

root.render(<App />);
